export const ignoreErrors = [
  "You do not have permission to perform this action",
  "Failed to fetch",
  "ApolloError: You do not have permission to perform this action",
  "Large Render Blocking Asset",
  "error Error: Failed to fetch",
  "This report is not yet paid",
  "Referral matching query does not exist",
];
